import Form from "Clutch/Atoms/Form";
import { GetOverboreValues, GetOverboreValuesInMM, Calculate, GetNumCylinders } from "./logic";
import { Default, Selected } from 'Clutch/Molecules/Button/Variants/OptionButtons'
import { useState, useEffect } from "react";
import Typography from "Clutch/Atoms/Typography";
import Button from "Clutch/Molecules/Button";
import ContextualError from "../common/contextualError";
import FormGroup from "../common/formGroup";
import styles from "./index.module.scss"

const EngineDisplacement = () => {

    const overboreValues = GetOverboreValues();
    const overboreValuesInMm = GetOverboreValuesInMM();
    const numCylindersValues = GetNumCylinders();

    const [isMetric, setIsMetric] = useState(false);
    const [bore, setBore] = useState(0);
    const [stroke, setStroke] = useState(0);
    const [numCylinders, setNumCylinders] = useState(numCylindersValues[0].value);
    const [overbore, setOverbore] = useState(overboreValues[0].value);
    const [result, setResult] = useState({
        isValid: false,
        errors: [],
        result: null,
        cubicInchesResult: null,
        litersResult: null
    });

    useEffect(() => {
        if (bore > 0 || stroke > 0) {
            const r = Calculate({ numCylinders, bore, stroke, overbore, isMetric });
            setResult(r)
        }
    }, [isMetric]);

    const CalculateInternal = (e) => {
        e.preventDefault()
        const r = Calculate({ numCylinders, bore, stroke, overbore, isMetric });
        setResult(r)
    }

    const numCylindersError = result.errors.find(x => x.id == 'numCylinders');
    const boreError = result.errors.find(x => x.id == 'bore');
    const strokeError = result.errors.find(x => x.id == 'stroke');
    const overboreError = result.errors.find(x => x.id == 'overbore');

    let InchesButton = isMetric ? Default : Selected
    let MillimetersButton = isMetric ? Selected : Default

    return <Form onSubmit={CalculateInternal}>
        <FormGroup>
            <div className={styles.optionButton}>
                <InchesButton
                    value={{ displayName: 'Inches' }}
                    brand={'primary'}
                    size={5}

                    onClick={() => setIsMetric(false)} />
                <MillimetersButton
                    value={{ displayName: 'Millimeters' }}
                    brand={'primary'}
                    size={5}
                    onClick={() => setIsMetric(true)}
                />
            </div>

            <br /> <br />
            <Form.Textbox
                fill
                id={'bore'}
                label={`Bore (${!isMetric ? "inches" : "millimeters"})`}
                intent={boreError ? 'negative' : null}
                value={bore}
                onChange={(e) => { setBore(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={boreError} />
        </FormGroup>
        <FormGroup>
            <Form.Select
                id={'overbore'}
                label={`Overbore (${!isMetric ? "inches" : "millimeters"})`}
                intent={overboreError ? 'negative' : null}
                options={!isMetric ? overboreValues : overboreValuesInMm}
                onChange={(e) => { setOverbore(e.target.value) }}
                value={overbore} />
            <ContextualError error={overboreError} />
        </FormGroup>
        <FormGroup>
            <Form.Textbox
                fill
                id={'stroke'}
                label={`Stroke (${!isMetric ? "inches" : "millimeters"})`}
                intent={strokeError ? 'negative' : null}
                value={stroke}
                onChange={(e) => { setStroke(e.target.value) }}
                type={'number'}
            />
            <ContextualError error={strokeError} />
        </FormGroup>

        <FormGroup>
            <Form.Select
                id={'numCylinders'}
                label={`Number of Cylinders`}
                intent={numCylindersError ? 'negative' : null}
                options={numCylindersValues}
                onChange={(e) => { setNumCylinders(e.target.value) }}
                value={numCylinders} />
            <ContextualError error={numCylindersError} />
        </FormGroup>

        <FormGroup>
            <Button intent={'action'} size={'small'} event={{}} text={"Calculate Engine Displacement"}></Button>
        </FormGroup>

        <FormGroup>
            {result.isValid ? <Typography as={'span'} size={1.25} font={'bold'}>{result.cubicInchesResult}</Typography> : false}
        </FormGroup>
        <FormGroup>
            {result.isValid ? <Typography as={'span'} size={1.25} font={'bold'}>{result.litersResult}</Typography> : false}
        </FormGroup>

    </Form>
}

export default EngineDisplacement